import { Table, Text } from '@quintoandar-tokko/jopijs';
import styles from '../dashboardTables.module.scss';
import PropertyOrDevelopmentCell from '../components/PropertyOrDevelopmentCell';
import ContactCell from '../components/ContactCell';
import AgentBranchCell from '../components/AgentBranchCell';
import ValueCell from '../components/ValueCell';

export default function AddedPropertiesTableRow({ addedProperty }) {
  const {
    id,
    property,
    operation,
    property_type,
    owner,
    agent,
    value,
    entry_date,
  } = addedProperty;

  return (
    <Table.RowDefault id={id} variant="secondary">
      <Table.RowItemDefault
        variant="secondary"
        className={styles.tableBodyCell}
      >
        <PropertyOrDevelopmentCell
          id={property?.id}
          thumbnail={property?.thumbnail}
          address={property?.address}
          location={property?.location}
          modal="addedProperties"
        />
      </Table.RowItemDefault>

      <Table.RowItemDefault
        variant="secondary"
        className={styles.tableBodyCell}
      >
        <Text variant="body.fontSize13">{operation}</Text>
        <Text variant="body.fontSize13">{property_type}</Text>
      </Table.RowItemDefault>

      <Table.RowItemDefault
        variant="secondary"
        className={styles.tableBodyCell}
      >
        <ValueCell value={value} />
      </Table.RowItemDefault>

      <Table.RowItemDefault
        variant="secondary"
        className={styles.tableBodyCell}
      >
        <ContactCell
          highlighted={false}
          id={owner?.id}
          image={owner?.image}
          name={owner?.name}
          email={owner?.email}
          cellphone={owner?.cellphone}
          leadStatus={owner?.lead_status}
          agent={agent}
          relativeSelector="#added-properties-modal"
          modal="addedProperties"
        />
      </Table.RowItemDefault>

      <Table.RowItemDefault
        variant="secondary"
        className={styles.tableBodyCell}
      >
        <AgentBranchCell
          agentId={agent?.id}
          agentName={agent?.name}
          branchName={agent?.branch_name}
          image={agent?.profile_picture}
          relativeSelector="#added-properties-modal"
          withBranch
          withBoldTitle
          modal="addedProperties"
        />
      </Table.RowItemDefault>

      <Table.RowItemDefault
        variant="secondary"
        className={styles.tableBodyCell}
      >
        <Text variant="body.fontSize13">{entry_date}</Text>
      </Table.RowItemDefault>
    </Table.RowDefault>
  );
}
